/**
 * Paths for Nasdaq Private Market private-company data.
 * - proxy: under our Next.js API (/api-next/investors*)
 * - upstream: data-api-pro /api/v1/npm/* (upstream path segment; Nasdaq Private Market)
 */
export const investorsRoutes = {
  companies: { proxy: 'investors/companies', upstream: 'api/v1/npm/companies' },
  funding: { proxy: 'investors/funding', upstream: 'api/v1/npm/funding' },
  investors: { proxy: 'investors', upstream: 'api/v1/npm/investors' },
  management: { proxy: 'investors/management', upstream: 'api/v1/npm/management' },
  pricing: { proxy: 'investors/pricing', upstream: 'api/v1/npm/pricing' },
} as const;
